import { memo } from 'react';
import { HStack, VStack } from '@cbhq/cds-web/layout';
import { TextHeadline } from '@cbhq/cds-web/typography';
import { TIME_PERIODS_SECONDS } from '@/utils/timeConstants';

export type TimeRange = '1H' | '1D' | '1W' | '1M' | '1Y' | 'All';

const timeRanges: TimeRange[] = ['1H', '1D', '1W', '1M', '1Y', 'All'];

// Milliseconds per second for conversion
const MS_PER_SECOND = 1000;

// Time range durations in milliseconds (derived from shared seconds constants)
export const TIME_RANGE_MS: Record<TimeRange, number> = {
  '1H': TIME_PERIODS_SECONDS.ONE_HOUR * MS_PER_SECOND,
  '1D': TIME_PERIODS_SECONDS.TWENTY_FOUR_HOURS * MS_PER_SECOND,
  '1W': TIME_PERIODS_SECONDS.SEVEN_DAYS * MS_PER_SECOND,
  '1M': TIME_PERIODS_SECONDS.THIRTY_DAYS * MS_PER_SECOND,
  '1Y': TIME_PERIODS_SECONDS.ONE_YEAR * MS_PER_SECOND,
  All: TIME_PERIODS_SECONDS.TWO_YEARS * MS_PER_SECOND,
};

type TimeRangeSelectorProps = {
  activeTimeRange: TimeRange;
  onTimeRangeChange: (range: TimeRange) => void;
};

export const TimeRangeSelector = memo(function TimeRangeSelector({
  activeTimeRange,
  onTimeRangeChange,
}: TimeRangeSelectorProps) {
  return (
    <HStack gap={0.5}>
      {timeRanges.map((range) => (
        <VStack
          key={range}
          paddingX={1.5}
          paddingY={1}
          borderRadius={1000}
          background={activeTimeRange === range ? 'bgPrimaryWash' : undefined}
          onClick={() => onTimeRangeChange(range)}
          style={{ cursor: 'pointer' }}
        >
          <TextHeadline as="span" color={activeTimeRange === range ? 'fgPrimary' : 'fgMuted'}>
            {range}
          </TextHeadline>
        </VStack>
      ))}
    </HStack>
  );
});
